import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { CircularProgress, Sheet, Stack, Typography } from "@mui/joy";
import StatsGrid from "./StatsGrid";
import ApplicantsList from "./ApplicantsList";
import totalEmployers from "../../assets/svgs/totalemployers.svg";
import totalApplicants from "../../assets/svgs/totalapplicants.svg";
import superApply from "../../assets/svgs/super-apply.svg";
import { fetchDashboardData } from "../../redux/adminSlice";
import { AppDispatch, RootState } from "../../redux/store";
import { useSelector } from "react-redux";

const Dashboard: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const dashboardData = useSelector(
    (state: RootState) => state?.admin?.data?.data
  );
  const loading = useSelector((state: RootState) => state.admin.status);

  useEffect(() => {
    dispatch(fetchDashboardData());
  }, [dispatch]);

  const stats = [
    {
      label: "Total Employers",
      value: dashboardData?.totalEmployers,
      icon: totalEmployers,
    },
    {
      label: "Total People",
      value: dashboardData?.totalApplicants,
      icon: totalApplicants,
    },
    {
      label: "Super Apply",
      value: dashboardData?.totalSuperApplied,
      icon: superApply,
    },
  ];

  return (
    <>
      {loading === "loading" ? (
        <div className="flex justify-center items-center h-[100vh]">
          <CircularProgress size="lg" />
        </div>
      ) : (
        <Sheet
          sx={{
            minHeight: "100vh",
            backgroundColor: "#F4F4F4",
            px: 2,
            py: 4,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Stack
            spacing={3}
            width="100%"
            sx={{ maxWidth: { xs: "100%", md: "650px" }, mx: "auto" }}
          >
            <Typography level="modalHeading">Dashboard</Typography>
            <StatsGrid stats={stats} />
            <ApplicantsList applicants={dashboardData?.latestApplicants} />
          </Stack>
        </Sheet>
      )}
    </>
  );
};

export default Dashboard;
